import {
    Admin, Resource, EditGuesser, Layout,
    houseLightTheme, houseDarkTheme,
    ListGuesser
} from "react-admin";
import { createAuthProvider, createDataProvider } from "./services";
import {
    ClaimedDayList,
    PhotoList,
    UserList, UserCreate, UserEdit,
    MessageList,
    ConversationList, ConversationShow,
    CreditsLogList,
    ReportList,
    UserLikeList,
    UserLikeMatchList,

    SubscriptionProductEdit, SubscriptionProductCreate, SubscriptionProductList,
    CreditProductEdit, CreditProductCreate, CreditProductList,
    AnnounceList, AnnounceEdit, AnnounceCreate,
    DepositsList,
    EmailDomainList,
    EmailDomainEdit,
    EmailDomainCreate,
    MailBatchList,
    MailBatchEdit,
    MailBatchCreate,
    MoodList,
    MoodEdit,
    MoodCreate,
    TransactionList,
    TransactionShow,
    Dashboard,
    TenantList,
    TenantEdit,
    TenantCreate,
    LocaleList,
    LocaleEdit,
    SettingsList,
    SettingsEdit
} from "./Screens";
import { AppMenu } from "./Menu/AppMenu";
import { createBrowserRouter, RouterProvider } from "react-router";
import { Appbar } from "./AppBar/Appbar";
import { PropsWithChildren } from "react";

import Face2OutlinedIcon from '@mui/icons-material/Face2Outlined';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import Diversity1OutlinedIcon from '@mui/icons-material/Diversity1Outlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AssuredWorkloadOutlinedIcon from '@mui/icons-material/AssuredWorkloadOutlined';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import SettingsApplicationsOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined';
import { BulkMessageList } from "./Screens/BulkMessage";
const authProvider = createAuthProvider()
const dataProvider = createDataProvider();

const ApLayout = ({ children }: PropsWithChildren) =>
    <Layout
        menu={AppMenu}
    // appBar={Appbar}
    >{children}</Layout>
function App() {

    const router = createBrowserRouter([
        {
            path: "*",
            element: (
                <Admin
                    theme={houseLightTheme}
                    darkTheme={houseDarkTheme}
                    dataProvider={dataProvider} authProvider={authProvider}
                    dashboard={Dashboard}
                    layout={ApLayout}
                >

                    <Resource name="city" />
                    <Resource name="country" />
                    <Resource name="product" />

                    <Resource name="photo" list={PhotoList} options={{ group: "User" }}
                        icon={Face2OutlinedIcon} />
                    <Resource name="user" list={UserList} edit={UserEdit} create={UserCreate}
                        icon={PersonSearchOutlinedIcon} options={{ group: "User" }} />
                    <Resource name="message" list={MessageList} options={{ group: "User" }}
                        icon={MessageOutlinedIcon} />
                    <Resource name="conversation" list={ConversationList} show={ConversationShow}
                        icon={ForumOutlinedIcon}
                        options={{ group: "User", label: "Chats" }} />
                    <Resource name="userlike" list={UserLikeList}
                        icon={FavoriteBorderOutlinedIcon}
                        options={{ group: "User", label: "Likes" }} />
                    <Resource name="userlikematch" list={UserLikeMatchList}
                        options={{ group: "User", label: "Matches" }}
                        icon={Diversity1OutlinedIcon}
                    />
                    <Resource name="report" list={ReportList} options={{ group: "User" }}
                        icon={ListAltOutlinedIcon}
                    />
                    <Resource name="bulkmessage" list={BulkMessageList} options={{ group: "User" }} />
                    <Resource name="SubscriptionProduct" list={SubscriptionProductList} edit={SubscriptionProductEdit} create={SubscriptionProductCreate}
                        options={{ label: "Subscriptions", group: "Product" }} />
                    <Resource name="CreditsProduct" list={CreditProductList} edit={CreditProductEdit} create={CreditProductCreate}
                        options={{ label: "Credits", group: "Product" }} />

                    <Resource name="CreditsLog" list={CreditsLogList} options={{ group: "Finance" }}
                        icon={CreditCardOutlinedIcon}
                    />
                    <Resource name="ClaimedDay" list={ClaimedDayList} options={{ group: "Finance" }}
                        icon={EventRepeatOutlinedIcon}
                    />
                    <Resource name="transaction" list={TransactionList} show={TransactionShow} options={{ group: "Finance" }}
                        icon={AccountBalanceOutlinedIcon}
                    />
                    <Resource name="deposit" list={DepositsList} options={{ group: "Finance" }}
                        icon={AssuredWorkloadOutlinedIcon}
                    />
                    <Resource name="mailbatch" list={MailBatchList} edit={MailBatchEdit} create={MailBatchCreate}
                        options={{ label: "Mail Batch", group: "Tools" }}
                        icon={ContactMailOutlinedIcon}
                    />

                    <Resource name="announce" list={AnnounceList} edit={AnnounceEdit} create={AnnounceCreate} options={{ group: "Tools" }}
                        icon={CampaignOutlinedIcon}
                    />
                    <Resource name="mood" list={MoodList} edit={MoodEdit} create={MoodCreate} options={{ group: "Tools" }}
                        icon={SentimentVerySatisfiedOutlinedIcon}
                    />
                    <Resource name="emaildomain" list={EmailDomainList} edit={EmailDomainEdit} create={EmailDomainCreate}
                        options={{ group: "Tools", label: "Email Domains" }}
                        icon={AlternateEmailOutlinedIcon}
                    />

                    <Resource name="tenant" list={TenantList} edit={TenantEdit} create={TenantCreate}
                        options={{ group: "Tools", label: "Tenants" }}
                        icon={EngineeringOutlinedIcon}
                    />
                    <Resource name="locale" list={LocaleList} edit={LocaleEdit} options={{ group: "Tools", label: "Locales" }}
                        icon={TranslateOutlinedIcon}
                    />
                    <Resource name="settings" list={SettingsList} edit={SettingsEdit} options={{ group: "Tools", label: "Settings" }}
                        icon={SettingsApplicationsOutlinedIcon}
                    />
                </Admin>
            ),
        },
    ]);
    return <RouterProvider router={router} />;
}

export default App
